import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
export default {
  getMrTableDownload (ctx, data) {
    return fetch.getMrTableDownload(data).then(res => {
      return res
    })
  },
  getInOutTableDownload (ctx, data) {
    return fetch.getInOutTableDownload(data).then(res => {
      return res
    })
  }
}